import React from 'react';
import { IStoreProps } from '../index';
import CartItem from './cart-item';

interface ICartItems {
    storeProps: IStoreProps;
}

const CartItems = ({ storeProps }: ICartItems) => {
    const { useAppSelector } = storeProps;

    const cartData = useAppSelector(store => store.root.cartData);
    const cartItems = cartData?.cartItems.filter(cartItem => cartItem.isActive);
    const isLoading = useAppSelector(store => store.root.isLoading);

    return (
        <div className={`overflow-auto px-2 flex flex-col`}
             style={{
                maxHeight: '300px',
            }}>
            {
                !isLoading && cartItems?.map(cartItem => {
                    return (
                        <CartItem
                            key={ cartItem.cartItemGUID }
                            cartItem={ cartItem }
                            storeProps={ storeProps }
                        />
                    )
                })
            }
        </div>
    )
};

export default CartItems;
